
























































import { defineComponent } from '@vue/composition-api';
import { FCCard } from '@fc/angie-ui';
import { useModal } from '~/composables/useModal';
import FCImage from '~/components/FCImage.vue';

export default defineComponent({
  name: 'MemberStoryCard',
  components: {
    FCCard,
    FCImage,
  },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      required: true,
    },
    memberName: {
      type: String,
      required: true,
    },
    quote: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    description2: {
      type: String,
      required: false,
      default: '',
    },
    videoUrl: {
      type: String,
      required: false,
      default: '',
    },
    mobileVideoUrl: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props: any) {
    const openVideoModal = () => {
      if (!props.videoUrl) return;

      const { modalShow } = useModal({
        component: () => import('~/components/v5/VideoDialog.vue'),
        componentProps: {
          videoUrl: props.videoUrl,
          mobileVideoUrl: props.mobileVideoUrl,
          videoId: `member-story-${props.memberName}`,
          isEmbed: false,
          posterImage: props.imageUrl,
        },
        modalProps: {
          componentName: 'VideoDialog',
          width: '90%',
          maxWidth: 1200,
          height: 'auto',
          reset: true,
        },
      });

      modalShow();
    };

    return {
      openVideoModal,
    };
  },
});
